import React from 'react'

import { useDashboardModals } from 'contexts/DashboardModalsContext'
import {
  CreateDashboardFolderModal,
  EditDashboardFolderModal,
  DeleteDashboardFolderModal,
  SelectDashboardFolderModal,
} from 'modules/dashboard'

import CreateDashboardModal from './CreateDashboardModal'
import DeleteDashboardModal from './DeleteDashboardModal'
import EditDashboardModal from './EditDashboardModal'

export default function DashboardModals() {
  const {
    isCreateDashboardModalOpen,
    isEditDashboardModalOpen,
    isDeleteDashboardModalOpen,
    isCreateDashboardFolderOpen,
    isDeleteDashboardFolderOpen,
    isEditDashboardFolderOpen,
    isSelectDashboardFolderModalOpen,
  } = useDashboardModals()

  return (
    <>
      {isCreateDashboardModalOpen && <CreateDashboardModal />}

      {isEditDashboardModalOpen && <EditDashboardModal />}

      {isDeleteDashboardModalOpen && <DeleteDashboardModal />}

      {isCreateDashboardFolderOpen && <CreateDashboardFolderModal isOpen={isCreateDashboardFolderOpen} />}

      {isDeleteDashboardFolderOpen && <DeleteDashboardFolderModal isOpen={isDeleteDashboardFolderOpen} />}

      {isEditDashboardFolderOpen && <EditDashboardFolderModal isOpen={isEditDashboardFolderOpen} />}

      {isSelectDashboardFolderModalOpen && <SelectDashboardFolderModal isOpen={isSelectDashboardFolderModalOpen} />}
    </>
  )
}
